import { useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import MandatorySign from "../Components/MandatorySign";
import InputSchedule from "./ModalInputs/Trigger/Schedule";
import InputManual from "./ModalInputs/Trigger/Manual";
import InputAgent from "./ModalInputs/Agent";
import InputNote from "./ModalInputs/Note";
import InputIf from "./ModalInputs/Conditions/If";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const ModalInputWorkflows = ({
    orderedNodes,
    show,
    handleClose,
    selectedItem,
    selectedNode,
    onSelectNode,
    setSelectedNode,
    setSelectedNodeId,
    setOpenOverDropdown,
    mcpData,
    fetchMcpData,
    loadingMcpData,
    executeNode,
    executionHistory
}) => {
    const handleSelect = (type, item, params) => {
        if (selectedNode) {
            onSelectNode(type, item, params, selectedNode.id);
        } else {
            onSelectNode(type, item, params);
        }

        CloseModal()
    };

    const CloseModal = () => {
        handleClose()
        setSelectedNode(null);
        setSelectedNodeId(null);
        setOpenOverDropdown(false);
    }

    return (
        <Modal show={show} centered onHide={CloseModal}>
            <div className="modal_header">
                <p className="modal_header_title">{selectedItem?.label}</p>
            </div>

            {selectedItem?.value == "default" && (
                <InputNote
                    handleClose={CloseModal}
                    handleSelect={handleSelect}
                    selectedItem={selectedItem}
                    selectedNode={selectedNode}
                />
            )}

            {selectedItem?.value == "note" && (
                <InputNote
                    handleClose={CloseModal}
                    handleSelect={handleSelect}
                    selectedItem={selectedItem}
                    selectedNode={selectedNode}
                />
            )}

            {selectedItem?.value == "manual" && (
                <InputManual
                    handleClose={CloseModal}
                    handleSelect={handleSelect}
                    selectedItem={selectedItem}
                    selectedNode={selectedNode}
                />
            )}

            {selectedItem?.value == "schedule" && (
                <InputSchedule
                    handleClose={CloseModal}
                    handleSelect={handleSelect}
                    selectedItem={selectedItem}
                    selectedNode={selectedNode}
                />
            )}


            {selectedItem?.value == "agent" && (
                <InputAgent
                    orderedNodes={orderedNodes}
                    executeNode={executeNode}
                    handleClose={CloseModal}
                    handleSelect={handleSelect}
                    selectedItem={selectedItem}
                    selectedNode={selectedNode}
                    mcpData={mcpData}
                    fetchMcpData={fetchMcpData}
                    loadingMcpData={loadingMcpData}
                    executionHistory={executionHistory}

                />
            )}

            {selectedItem?.value == "if" && (
                <InputIf
                    orderedNodes={orderedNodes}
                    executeNode={executeNode}

                    handleClose={CloseModal}
                    handleSelect={handleSelect}
                    selectedItem={selectedItem}
                    selectedNode={selectedNode}
                    executionHistory={executionHistory}
                />
            )}

        </Modal>
    );
};

export default ModalInputWorkflows;